import { ComponentNextLinkProps } from "@keepeek/refront-components";
import { Element } from "domhandler";
import { domToReact, HTMLReactParserOptions } from "html-react-parser";
import Link from "next/link";

export const ComponentNextLink = function ({
  href,
  children,
  target,
  className,
  title,
  testId,
  rel,
  handleClickLink,
}: ComponentNextLinkProps) {
  if (handleClickLink) {
    return (
      <a
        onClick={handleClickLink}
        className={className ?? ""}
        title={title ?? undefined}
        data-testid={testId}
        rel={rel}
        target={!handleClickLink ? target ?? "_self" : ""}
        style={{ cursor: "pointer" }}
      >
        {children}
      </a>
    );
  }
  if (href && href.trim() !== "" && href !== "about:blank") {
    return (
      <Link passHref href={href} legacyBehavior style={{ cursor: "pointer" }}>
        <a
          className={className ?? ""}
          title={title ?? undefined}
          data-testid={testId}
          rel={rel}
          target={!handleClickLink ? target ?? "_self" : ""}
        >
          {children}
        </a>
      </Link>
    );
  }
  return <>{children}</>;
};

export const parseOptionsInternalUrl: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (
      domNode.nodeType === 1 &&
      domNode.type === "tag" &&
      (domNode as Element)?.name === "a" &&
      ((domNode as Element)?.attribs.target === "_self" || !(domNode as Element)?.attribs.target) &&
      (domNode as Element)?.attribs.href
    ) {
      return (
        <ComponentNextLink href={(domNode as Element).attribs.href}>
          {domToReact((domNode as Element).children)}
        </ComponentNextLink>
      );
    }
  },
};
